const PrizeDrawCmsSchema = [
  {
    id: 'title',
    validationType: 'string',
    field: 'Title',
    validations: [
      {
        type: 'required',
        params: ['Title is required'],
      },
    ],
  },
  {
    id: 'first_name',
    validationType: 'string',
    field: 'FirstName',
    validations: [
      {
        type: 'required',
        params: ['First name is required'],
      },
      {
        type: 'min',
        params: [2, 'First name must be at least 2 characters'],
      },
      {
        type: 'max',
        params: [50, 'First name must be at most 50 characters'],
      },
      {
        type: 'matches',
        params: [
          /^[A-Za-z-.,'` ]{1,50}$/,
          'First name can only contain letters and basic punctuation',
        ],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'last_name',
    validationType: 'string',
    field: 'LastName',
    validations: [
      {
        type: 'required',
        params: ['Last name is required'],
      },
      {
        type: 'min',
        params: [2, 'Last name must be at least 2 characters'],
      },
      {
        type: 'max',
        params: [50, 'Last name must be at most 50 characters'],
      },
      {
        type: 'matches',
        params: [
          /^[A-Za-z-.,'` ]{1,50}$/,
          'First name can only contain letters and basic punctuation',
        ],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'email',
    validationType: 'string',
    field: 'Email',
    validations: [
      {
        type: 'required',
        params: ['Email is required'],
      },
      {
        type: 'matches',
        params: [
          /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
          'Email must be a valid email address',
        ],
      },
      {
        type: 'max',
        params: [255],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'tel',
    validationType: 'string',
    field: 'Tel',
    validations: [
      {
        type: 'required',
        params: ['Phone is required'],
      },
      {
        type: 'matches',
        params: [
          /^\d{7,11}$/,
          {
            message: 'Please enter a valid telephone number',
            excludeEmptyString: true,
          },
        ],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'tel_optional',
    validationType: 'string',
    field: 'Tel_optional',
    validations: [
      {
        type: 'matches',
        params: [
          /^\d{7,11}$/,
          {
            message: 'Please enter a valid telephone number',
            excludeEmptyString: true,
          },
        ],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'preference',
    validationType: 'string',
    field: 'DropDown',
    validations: [
      {
        type: 'required',
        params: ['Please select an option'],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'response_code',
    validationType: 'string',
    validations: [
      {
        type: 'uppercase',
        params: [],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'campaign_code',
    validationType: 'string',
    validations: [
      {
        type: 'uppercase',
        params: [],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'campaign_response_code',
    validationType: 'string',
    validations: [
      {
        type: 'uppercase',
        params: [],
      },
      {
        type: 'trim',
        params: [],
      },
    ],
  },
  {
    id: 'is_lexus',
    validationType: 'boolean',
    validations: [],
  },
]

export default PrizeDrawCmsSchema
